import { ArrowsNavigation } from "PFComponents/arrows_navigation";
import Toggle from "PFComponents/toggle/toggle";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import css from "./kpis_review_footer.module.scss";

type KPIsReviewFooterProps = {
  currentIndex: number;
  totalCount: number;
  onlyExceptions: boolean;
  isAnyNotCompliant: boolean;
  setOnlyExceptions: Dispatch<SetStateAction<boolean>>;
  onPrevClick: VoidFunction;
  onNextClick: VoidFunction;
};

export const KPIsReviewFooter = ({
  currentIndex,
  totalCount,
  onlyExceptions,
  isAnyNotCompliant,
  setOnlyExceptions,
  onPrevClick,
  onNextClick
}: KPIsReviewFooterProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "KPIsReviewSidepanel" });

  return (
    <footer className={css.footer}>
      <Toggle
        checked={onlyExceptions}
        onChange={setOnlyExceptions}
        label={t("onlyKPIsWithExceptions")}
        disabled={!isAnyNotCompliant}
        inline
        reversed
        compact
      />
      <ArrowsNavigation
        currentIndex={currentIndex}
        totalCount={totalCount}
        prevAriaLabel={t("previousKPI")}
        nextAriaLabel={t("nextKPI")}
        onPrevClick={onPrevClick}
        onNextClick={onNextClick}
      />
    </footer>
  );
};
